/**
 * Scrolls the element the controller is attached to into view on connect
 *
 * Accepts behavior, block, and inline values, corresponding to options passed to the
 * scrollIntoView method.
 *
 * Also accepts a modal id value, which causes the controller to wait for the modal to be
 * shown before attempting to scroll (trying to scroll on connect will fail if content is
 * within a modal that is not yet done appearing).
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    behavior: { type: String, default: "instant" },
    block: { type: String, default: "start" },
    inline: { type: String, default: "nearest" },
    modalId: String,
  };

  connect() {
    if (this.hasModalIdValue) {
      document
        .getElementById(this.modalIdValue)
        .addEventListener("shown.bs.modal", this.scrollIntoView.bind(this), { once: true });
    } else {
      this.scrollIntoView();
    }
  }

  scrollIntoView() {
    this.element.scrollIntoView({
      behavior: this.behaviorValue,
      block: this.blockValue,
      inline: this.inlineValue,
    });
  }
}
